import React, { Suspense, useContext } from 'react'
import Home from './pages/home/Home'
import List from './pages/list/List'
import Single from './pages/single/Single'
import New from './pages/new/New'
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom'
import {
  userInputs,
  assetCategoryInput,
  RolesInput,
  companyInputs,
  assetConditionInput,
  otherAssetsCitiesInput,
  employeeListInput,
  brandListInput,
  departmentInputs
} from './formSource'
import './style/dark.scss'
import { DarkModeContext } from './context/darkModeContext'
// import Login from "./pages/login/Login";
import AdminLogin from './components/adminLogin/AdminLogin.js'
import DatabaseConfig from './pages/databaseConfig/DatabaseConfig'
import Login from './components/signUpComponent/LoginPage'
import SignUp from './components/signUpComponent/SignUp'
import Forget from './components/signUpComponent/Forget'

// userAdminPanelPages
import UserLogin from './pages/userAdminPanelPages/Pages/Login'
import AssetsDashboard from './pages/userAdminPanelPages/Pages/AssetsDashboard'
import NewAssetGenerate from './pages/userAdminPanelPages/Pages/NewAssetGenerate'
import UserPrinting from './pages/userAdminPanelPages/Pages/PrintingAsset'
import VerifiedAsset from './pages/userAdminPanelPages/Pages/VerifiedAsset'
import PrintingAsset2 from './pages/userAdminPanelPages/Pages/PrintingAsset2'

// userAdminPanel Components
import Category from './components/userAdminPanel/Components/Category'
import Details from './components/userAdminPanel/Components/Details'
import AllAssetsPage from './pages/allAssets/AllAssetsPage'
import AddAllAsset from './components/allAssets/AddAllAsset'
import UpdateAllAsset from './components/allAssets/UpdateAllAsset'
import LocationTagsPage from './pages/locationTagsPage/LocationTagsPage'
import UserAccountPage from './pages/userAccountPage/UserAccountPage'
import AssetVerification from './pages/userAdminPanelPages/Pages/AssetVerification'
import AssetCustodian from './pages/userAdminPanelPages/Pages/AssetCustodian'
import AssetLocation from './pages/userAdminPanelPages/Pages/AssetLocation'
import AssetMovement from './pages/userAdminPanelPages/Pages/AssetMovement'
import LocationDetails from './pages/userAdminPanelPages/Pages/LocationDetails'
import CustodianDetails from './pages/userAdminPanelPages/Pages/CustodianDetails'
import AssetCategoriesForm from './components/databaseConfig/assetCategories/AssetCategoryForm'
import AssetCategoriesUpdateForm from './components/databaseConfig/assetCategories/AssetCategoriesUpdateForm'
import AddNewRoleForm from './components/databaseConfig/allRoles/AddNewRoleForm'
import UpdateRoleForm from './components/databaseConfig/allRoles/UpdateRoleForm'
import AddAssetConditionForm from './components/databaseConfig/assetOtherData/AddAssetConditionForm'
import UpdateAssetConditionForm from './components/databaseConfig/assetOtherData/UpdateAssetConditionForm'
import AddOtherAssetsCitiesForm from './components/databaseConfig/assetOtherData/AddOtherAssetsCitiesForm'
import UpdateOtherAssetsCitiesForm from './components/databaseConfig/assetOtherData/UpdateOtherAssetsCitiesForm'
import AddEmployeeListForm from './components/databaseConfig/assetOtherData/AddEmployeeListForm'
import UpdateEmployeeListForm from './components/databaseConfig/assetOtherData/UpdateEmployeeListForm'
import AddBrandListForm from './components/databaseConfig/brandList/AddBrandListForm'
import UpdateBrandListForm from './components/databaseConfig/brandList/UpdateBrandListForm'
import AddDepartmentForm from './components/databaseConfig/department/AddDepartmentForm'
import UpdateDepartmentForm from './components/databaseConfig/department/UpdateDepartmentForm'
import AddNewUser from './components/userAccount/AddNewUser'
import Settings from './pages/settings/Settings'
import CompanyInfo from './pages/CompanyInfo/CompanyInfo'
import NewAssetGenerate2 from './pages/userAdminPanelPages/Pages/NewAssetGenerate2'
import Mainhomepage from './pages/home/Mainhomepage.jsx'
import Sidebarfats from './components/sidebar/Sidebarfats.jsx'
import Sidebar from './components/sidebar/Sidebar.jsx'
import Navbar from './components/navbar/Navbar.jsx'
import { useTranslation } from 'react-i18next'
import Template1 from './pages/userAdminPanelPages/PagesTemplates/Template1/Template1.jsx'
import Template2 from './pages/userAdminPanelPages/PagesTemplates/Template2/Template2.jsx'
import Template3 from './pages/userAdminPanelPages/PagesTemplates/Template3/Template3.jsx'
import Template4 from './pages/userAdminPanelPages/PagesTemplates/Template4/Template4.jsx'
import Template5 from './pages/userAdminPanelPages/PagesTemplates/Tempate5/Template5.jsx'
import Template6 from './pages/userAdminPanelPages/PagesTemplates/Template6/Template6.jsx'
import Template7 from './pages/userAdminPanelPages/PagesTemplates/Template7/Template7.jsx'
import BlogPages from './pages/UserPages/BlogPages/BlogPages.jsx'
import Megamenu from './pages/userAdminPanelPages/Frontend/MegaMenu/Megamenu.jsx'
import Categories from './pages/userAdminPanelPages/Frontend/Categories/Categories.jsx'
import Footermenu from './pages/userAdminPanelPages/Frontend/Footermenu/Footermenu.jsx'
import { QueryClient, QueryClientProvider } from 'react-query'
import Adminheader from './pages/userAdminPanelPages/Frontend/Header/Adminheader.jsx'
import Stepters from './pages/userAdminPanelPages/Frontend/Stepter/Stepters.jsx'
import Sliders from './pages/userAdminPanelPages/Frontend/Silder/Sliders.jsx'
import Resources from './pages/userAdminPanelPages/Frontend/Resources/Resources.jsx'
import Cardsection from './pages/userAdminPanelPages/Frontend/Cardfirstsection/Cardsection.jsx'
import Faqs from './pages/userAdminPanelPages/Frontend/FAQS/Faqs.jsx'
import Language from './pages/userAdminPanelPages/Frontend/Language/Language.jsx'
import Cardsection2 from './pages/userAdminPanelPages/Frontend/Cardsection2/Cardsection2.jsx'
import Headingshome from './pages/userAdminPanelPages/Frontend/Headingssection/Headingshome.jsx'
import DataTableProvider from './context/DataTableContext.js'
import { LanguageProvider } from './context/LanguageContext.jsx'
import { SnackbarProvider } from './context/SnackbarContext.jsx'
import ViewVerifiedAsset from './components/verifiedAsset/ViewVerifiedAsset.jsx'
import AssetsDashboardCards from './pages/userAdminPanelPages/Pages/AssetsDashboardCards.js'

const queryClient = new QueryClient()

function App () {
  const { darkMode } = useContext(DarkModeContext)
  const { t, i18n } = useTranslation()

  const MainLayout = ({ children }) => {
    return (
      <div className='main-layout-container'>
        <Sidebarfats />
        <span className='right-layout'>{children}</span>
      </div>
    )
  }

  const AdminMainLayout = ({ children }) => {
    return (
      <div
        className={`home flex ${
          i18n.language === 'ar' ? 'flex-row-reverse' : 'flex-row'
        }`}
      >
        <Sidebar />
        <div className='homeContainer'>
          <Navbar />
          <span className='right-layout'>{children}</span>
        </div>
      </div>
    )
  }

  const UserLayout = () => {
    return (
      <div>
        <QueryClientProvider client={queryClient}>
          <main className='w-full flex flex-col justify-center'>
            <Outlet /> {/* Nested routes will render here */}
          </main>
        </QueryClientProvider>
      </div>
    )
  }

  return (
    <LanguageProvider>
      <SnackbarProvider>
      {/* <Suspense fallback={<div>Loading translations...</div>}> */}
        <div className={darkMode ? 'app dark' : 'app'}>
          <DataTableProvider>
            <BrowserRouter>
              {/* User section */}
              <Routes>
                <Route element={<UserLayout />}>
                  <Route path='/' element={<Mainhomepage />} />
                  <Route path=':id' element={<BlogPages />} />
                  {/* AdminPanel Login, SignUp, Forgot Page */}
                  <Route path='admin-login' element={<Login />} />
                  <Route path='admin-signup' element={<SignUp />} />
                  <Route path='admin-forgot' element={<Forget />} />
                  {/* Userlogin */}
                  <Route path='/userlogin' element={<UserLogin />} />
                  <Route path='/login' element={<Login />} />
                </Route>
              </Routes>

              <Routes>
                {/* <Route index element={<AssetsDashboard />} /> */}
                <Route
                  path='new'
                  element={<New inputs={userInputs} title='Add New User' />}
                />
                {/* userAdminPanelPages */}
                <Route
                  path='member/*'
                  element={
                    <MainLayout>
                      <Routes>
                        {/* <Route path="dashboardTable" element={<DashboardTable />} /> */}
                        <Route path='userdetails' element={<Details />} />
                        {/* <Route path='assets' element={<AssetsDashboard />} /> */}
                        <Route path='assets' element={<AssetsDashboardCards />} />
                        {/* <Route path="newasset" element={<NewAssetGenerate />} /> */}
                        <Route
                          path='newasset'
                          element={<NewAssetGenerate2 />}
                        />
                        {/* <Route path="userprinting" element={<UserPrinting />} /> */}
                        <Route
                          path='userprinting'
                          element={<PrintingAsset2 />}
                        />
                        <Route
                          path='verifiedasset'
                          element={<VerifiedAsset />}
                        />
                        <Route
                          path='view-verifiedasset/:id'
                          element={<ViewVerifiedAsset />}
                        />
                        <Route path='verify' element={<AssetVerification />} />
                        <Route path='cust' element={<AssetCustodian />} />
                        <Route path='location' element={<AssetLocation />} />
                        <Route path='movement' element={<AssetMovement />} />
                        <Route
                          path='locationdetails'
                          element={<LocationDetails />}
                        />
                        <Route
                          path='custodian'
                          element={<CustodianDetails />}
                        />
                        <Route path='category' element={<Category />} />
                        <Route path='*' element={<AssetsDashboard />} />
                      </Routes>
                    </MainLayout>
                  }
                ></Route>

                {/* Admin */}
                <Route
                  path='admin/*'
                  element={
                    <AdminMainLayout>
                      <Routes>
                        <Route path='dashboard' element={<Home />} />
                      {/*  <Route path='settings' element={<Settings />} /> */}

                        {/* Template */}
                        <Route path='template1' element={<Template1 />} />
                        <Route path='template2' element={<Template2 />} />
                        <Route path='template3' element={<Template3 />} />
                        <Route path='template4' element={<Template4 />} />
                        <Route path='template5' element={<Template5 />} />
                        <Route path='template6' element={<Template6 />} />
                        <Route path='template7' element={<Template7 />} />
                        <Route path='Megamenu' element={<Megamenu />} />
                        <Route path='Categories' element={<Categories />} />
                        <Route path='footer_menu' element={<Footermenu />} />
                        <Route path='Header' element={<Adminheader />} />
                        <Route path='Stepter' element={<Stepters />} />
                        <Route path='Sliders' element={<Sliders />} />
                        <Route path='Resources' element={<Resources />} />
                        <Route path='Card' element={<Cardsection />} />
                        <Route path='Faqs' element={<Faqs />} />
                        <Route path='Language' element={<Language />} />
                        <Route path='cardsection' element={<Cardsection2 />} />
                        <Route path='Headings' element={<Headingshome />} />

                        <Route path='database-config/'>
                          <Route index element={<DatabaseConfig />} />
                          <Route
                            path='department'
                            element={<DatabaseConfig component='department' />}
                          />
                          <Route
                            path='department/add-new'
                            element={
                              <AddDepartmentForm
                                inputs={departmentInputs}
                                title='Add Department'
                              />
                            }
                          />
                          <Route
                            path='department/update/:id'
                            element={
                              <UpdateDepartmentForm
                                inputs={departmentInputs}
                                title='Update Department'
                              />
                            }
                          />
                          <Route path='asset-categories/'>
                            <Route
                              index
                              element={
                                <DatabaseConfig component='assetCategories' />
                              }
                            />
                            <Route
                              path='add-new-asset-category'
                              element={
                                <AssetCategoriesForm
                                  inputs={assetCategoryInput}
                                  title='New Assets Category'
                                />
                              }
                            />
                            <Route
                              path='update-asset-category/:id'
                              element={
                                <AssetCategoriesUpdateForm
                                  inputs={assetCategoryInput}
                                  title='Update Assets Category'
                                />
                              }
                            />
                          </Route>
                          <Route
                            path='users'
                            element={<DatabaseConfig component='users' />}
                          />
                          <Route
                            path='other-assets'
                            element={<DatabaseConfig component='otherAssets' />}
                          />
                          <Route
                            path='brand-list'
                            element={<DatabaseConfig component='brandList' />}
                          />
                          <Route
                            path='brand-list/add-new'
                            element={
                              <AddBrandListForm
                                inputs={brandListInput}
                                title='Add Brand'
                              />
                            }
                          />
                          <Route
                            path='brand-list/update/:id'
                            element={
                              <UpdateBrandListForm
                                inputs={brandListInput}
                                title='Update Brand'
                              />
                            }
                          />
                          <Route
                            path='other-assets-condition'
                            element={
                              <DatabaseConfig component='otherAssetContition' />
                            }
                          />
                          <Route
                            path='other-assets-condition/add-new'
                            element={
                              <AddAssetConditionForm
                                inputs={assetConditionInput}
                                title='Add Asset Condition'
                              />
                            }
                          />
                          <Route
                            path='other-assets-condition/update/:id'
                            element={
                              <UpdateAssetConditionForm
                                inputs={assetConditionInput}
                                title='Update Asset Condition'
                              />
                            }
                          />
                          <Route
                            path='employee-list'
                            element={
                              <DatabaseConfig component='otherAssetEmployeeList' />
                            }
                          />
                          <Route
                            path='employee-list/add-new'
                            element={
                              <AddEmployeeListForm
                                inputs={employeeListInput}
                                title='Add Employee'
                              />
                            }
                          />
                          <Route
                            path='employee-list/update/:id'
                            element={
                              <UpdateEmployeeListForm
                                inputs={employeeListInput}
                                title='Update Employee'
                              />
                            }
                          />
                          {/* <Route path="all-roles" element={<DatabaseConfig component="allRoles" />} /> */}
                          <Route path='all-roles/'>
                            <Route
                              index
                              element={<DatabaseConfig component='allRoles' />}
                            />
                            <Route
                              path='add-new-role'
                              element={
                                <AddNewRoleForm
                                  inputs={RolesInput}
                                  title='Add New Role'
                                />
                              }
                            />
                            <Route
                              path='update-role/:id'
                              element={
                                <UpdateRoleForm
                                  inputs={RolesInput}
                                  title='Update Role'
                                />
                              }
                            />
                          </Route>

                          <Route
                            path='other-assets-cities'
                            element={
                              <DatabaseConfig component='otherAssetsCities' />
                            }
                          />
                          <Route
                            path='other-assets-cities/add-new'
                            element={
                              <AddOtherAssetsCitiesForm
                                inputs={otherAssetsCitiesInput}
                                title='Add City'
                              />
                            }
                          />
                          <Route
                            path='other-assets-cities/update/:id'
                            element={
                              <UpdateOtherAssetsCitiesForm
                                inputs={otherAssetsCitiesInput}
                                title='Update City'
                              />
                            }
                          />
                        </Route>
                        {/* userAdminPanel Components */}
                        <Route path='users'>
                          <Route index element={<List />} />
                          <Route path=':userId' element={<Single />} />
                          <Route
                            path='new'
                            element={
                              <New inputs={userInputs} title='Add New User' />
                            }
                          />
                        </Route>
                        <Route path='stats'>
                          <Route index element={<Home page='stats' />} />
                        </Route>
                        <Route path='user'>
                          <Route index element={<List />} />
                          {/* <Route path=":userId" element={<Single />} /> */}

                          <Route
                            path='new'
                            element={
                              <New inputs={userInputs} title='Add New User' />
                            }
                          />
                        </Route>
                        <Route
                          path='all-assets/add-new'
                          element={<AddAllAsset />}
                        />
                        <Route
                          path='all-assets/update/:tagNumber'
                          element={<UpdateAllAsset />}
                        />
                        <Route path='all-assets' element={<AllAssetsPage />} />
                        <Route
                          path='loation-tags'
                          element={<LocationTagsPage />}
                        />
                        <Route
                          path='users-account/update-roles/:id/:name'
                          element={<UserAccountPage component='userRoles' />}
                        />
                        <Route
                          path='users-account'
                          element={<UserAccountPage component='userAccount' />}
                        />
                        <Route
                          path='users-account/add-new-user'
                          element={
                            <AddNewUser
                              inputs={userInputs}
                              title='Add New User'
                            />
                          }
                        />
                        <Route
                          path='company-info'
                          element={
                            <CompanyInfo
                              inputs={companyInputs}
                              title='Company Data'
                              permission='update'
                            />
                          }
                        />
                      </Routes>
                    </AdminMainLayout>
                  }
                ></Route>
              </Routes>
            </BrowserRouter>
          </DataTableProvider>
        </div>

      </SnackbarProvider>
      {/* </Suspense> */}
    </LanguageProvider>
  )
}

export default App
